import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import AuthCallback from "@/pages/AuthCallback";
import EspaceLeads from "@/pages/EspaceLeads";

function AppRouter() {
  const location = useLocation();
  // Process OAuth callback fragment before any route/auth check (prevents race condition)
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/espace-leads" element={<EspaceLeads />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-sand-light">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
